import StoryPieceEditor from './StoryPieceEditor.vue';

export default StoryPieceEditor;
